import SharePointSettingsRestService from '../SharePointSettingsRestService'
import React from "react"
import { TFunction } from "i18next"

class SharePointSettingsService {
    static async getAll(setSharePointCustomFields: React.Dispatch<any>) {
        try {
            const restProtectionConfigurations = await SharePointSettingsRestService.getAll()

            setSharePointCustomFields(restProtectionConfigurations)
        } catch (error) {
            return Promise.reject(error)
        }
    }

    static async getById(id: number): Promise<any> {
        try {
            return await SharePointSettingsRestService.getById(id)
        } catch (error) {
            return Promise.reject(error)
        }
    }

    static async create(sharePointCustomField: any, t: TFunction, setSharePointCustomFields: React.Dispatch<any>) {
        try {

            const createdPolicy = await SharePointSettingsRestService.create(sharePointCustomField)

            if (setSharePointCustomFields) {
                const restProtectionConfigurations = await SharePointSettingsRestService.getAll()
                setSharePointCustomFields(restProtectionConfigurations)
            }


            return t('sharePointSettings.createSuccess', { name: createdPolicy.name })
        } catch (error) {
            return Promise.reject(error)
        }
    }

    static async edit(sharePointCustomField: any, t: TFunction, setSharePointCustomFields: React.Dispatch<any>) {
        try {
            const editedPolicy = await SharePointSettingsRestService.update(sharePointCustomField)

            if (setSharePointCustomFields) {
                const restProtectionConfigurations = await SharePointSettingsRestService.getAll()
                setSharePointCustomFields(restProtectionConfigurations)
            }
            return t('sharePointSettings.updateSuccess', { name: editedPolicy.name })
        } catch (error) {
            return Promise.reject(error)
        }
    }

    static async delete(sharePointCustomField: any, t: TFunction, setSharePointCustomFields: React.Dispatch<any>) {
        try {
            await SharePointSettingsRestService.delete(sharePointCustomField.id)

            if (setSharePointCustomFields) {
                const restProtectionConfigurations = await SharePointSettingsRestService.getAll()
                setSharePointCustomFields(restProtectionConfigurations)
            }
            return t('sharePointSettings.deleteSuccess', { name: sharePointCustomField.name })
        } catch (error) {
            return Promise.reject(error)
        }
    }

}


export default SharePointSettingsService
